import { provide, inject } from 'vue';
import type { ComputedRef, InjectionKey } from 'vue';
import type { Vertical } from '../types/vertical';

const verticalKey: InjectionKey<ComputedRef<Vertical>> = Symbol('vertical');

/**
 * Set the currently used vertical theme.
 */
export default function useProvideVerticalTheme(vertical: ComputedRef<Vertical>): void {
	provide(verticalKey, vertical);
}

/**
 * Get the currently set vertical theme.
 */
export function useCurrentVerticalTheme() {
	return inject(verticalKey);
}
